import React from 'react'

import {
  BasicQuality,
  PremiumQuality,
  ProQuality,
  AIGenerated,
  Designer,
  Icon,
  Verified,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { ADVANCED_FILTER, QUALITY_LEVEL, CONTENT_SOURCE } from 'Pods/SearchPage/Store/constants'

export const qualityLevels = [
  { value: QUALITY_LEVEL.ANY, labelKey: 'any' },
  { value: QUALITY_LEVEL.BASIC, labelKey: 'basic', icon: BasicQuality },
  { value: QUALITY_LEVEL.PREMIUM, labelKey: 'premium', icon: PremiumQuality },
  { value: QUALITY_LEVEL.PRO, labelKey: 'pro', icon: ProQuality },
]

export const contentSources = [
  { value: CONTENT_SOURCE.ALL, labelKey: 'all' },
  { value: CONTENT_SOURCE.AI_GENERATED, labelKey: 'ai_generated', icon: AIGenerated },
  { value: CONTENT_SOURCE.HUMAN_CREATED, labelKey: 'human_created', icon: Designer },
]

export const CGT_STANDARD_SELECTED = [ADVANCED_FILTER.CGT_STANDARD_ONLY]

export const getCgtStandardConfig = (translate) => [{
  label: '',
  filters: [{
    value: ADVANCED_FILTER.CGT_STANDARD_ONLY,
    label: (
      <span className="filter-wrapper__option--with-icon">
        <span>{translate('search_page.filters.advanced.cgt_standard')}</span>
        <Icon notSpaced svgComponent={Verified} color="primary" size="small" />
      </span>
    ),
  }],
}]
